import React, { useEffect, useState } from "react";
import { LINKS } from "../../../api/Links";
import formatPhoneNumber from "../../../utils/formatPhoneNumber";

export default function Footer() {
  const [links, setLinks] = useState(null);

  const getLinksList = async () => {
    try {
      const res = await LINKS.GET_ALL();
      if (res.status !== 200) {
        throw new Error("Failed to fetch information");
      }
      setLinks(res.data[0]);
    } catch (error) {
      // console.log("Error loading topics: ", error);
    }
  };

  useEffect(() => {
    getLinksList();
  }, []);
  return (
    <div className="w-full flex flex-col justify-center items-center mt-10 py-10">
      <div className="w-5/6 max-w-screen-2xl flex lg:flex-row lg:justify-between flex-col justify-center">
        <div className="text-center lg:text-start py-1">
          <p className="font-bold">Encore Events</p>
          <p className="font-bold">Perumpilly, Kochi | Kerala, India</p>
        </div>
        <div className="text-center  py-1">
          <p>Privacy Policy</p>
          <p>Terms & Conditions</p>
        </div>
        <div className="text-center lg:text-end  py-1 flex flex-col">
          {links !== null && links !== undefined ? (
            <a
              href={`mailto:${links.mail}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {links.mail}
            </a>
          ) : (
            ""
          )}
          {links !== null && links !== undefined ? (
            <a
              href={`tel:+91${links.phone1}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              +91 {formatPhoneNumber(links.phone1)}
            </a>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="w-5/6 max-w-screen-2xl bg-black h-[1px] my-2"></div>
      <div className="w-5/6 max-w-screen-2xl flex lg:flex-row lg:justify-between flex-col justify-center">
        <div className="text-center lg:text-start py-1">
          <p>&#169; 2025 : Encore Events All Rights Reserved</p>
        </div>
        <div className="text-center lg:text-end py-1">
          <a
            href="https://wa.me/917356693134?text=Hi%2C%20I%20came%20across%20the%20website%20you%20developed%20for%20Encore%20Events%20and%20was%20very%20impressed.%20I%E2%80%99d%20like%20to%20learn%20more%20about%20your%20services%20and%20possibly%20discuss%20a%20new%20project."
            target="_blank"
            rel="noopener noreferrer"
          >
            Powered by : E
          </a>
        </div>
      </div>
    </div>
  );
}
